// const VARIANT_MAP = window.DONATION_VARIANTS || {};
const VARIANT_MAP = window.DONATION_VARIANTS || {};

// Build sorted list of allowed amounts from your variants
const allowedAmounts = Object.keys(VARIANT_MAP)
  .map(cents => parseInt(cents, 10) / 100) // back to NOK
  .sort((a, b) => a - b);

function closestAllowedAmount(amount) {
  const value = Number(amount);
  if (!value || allowedAmounts.length === 0) return null;

  // If below the smallest allowed amount → return the smallest
  if (value <= allowedAmounts[0]) return allowedAmounts[0];

  // If above the largest → return the largest
  if (value >= allowedAmounts[allowedAmounts.length - 1]) {
    return allowedAmounts[allowedAmounts.length - 1];
  }

  // Round DOWN: find the largest allowed amount <= value
  let result = allowedAmounts[0];

  for (const a of allowedAmounts) {
    if (a <= value) {
      result = a;  // update as long as it's <= value
    } else {
      break; // since array is sorted, we can stop
    }
  }

  return result;
}

document.addEventListener('change', (e) => {
  if(e.target.classList.contains("donation-variant")) {
    const donationFieldset = e.target.closest('.donation-fieldset');
    const donationForm = donationFieldset.closest('.donation-form');
    const amountContainer = donationForm.querySelector('.donation-amount-container');
    const submitButton    = donationForm.querySelector('.donation-submit');

    // Enable submit when something is selected
    submitButton.disabled = !e.target.value?.length;

    // Show amount input only when "custom" option is chosen

    donationFieldset.style.display = e.target.classList.contains('donation-variant-custom')
      ? 'none'
      : 'block';

    amountContainer.style.display = e.target.classList.contains('donation-variant-custom')
      ? 'block'
      : 'none';
  
  } else if(e.target.classList.contains("donation-format-variant")) {
    const donationFormat = e.target.value;
    const donationFormsContainer = e.target.closest('.donation-forms-container');
    donationFormsContainer.querySelectorAll('.donation-form:not([data-donation-format="' + donationFormat + '"])').forEach( el => { el.style.display = "none"} );
    donationFormsContainer.querySelectorAll('.donation-form[data-donation-format="' + donationFormat + '"]').forEach( el => { el.style.display = "block"} );
  } else {
    return;
  }
});


document.addEventListener('input', (e) => {
  if (!e.target.classList.contains('donation-amount')) return;

  const amountInput      = e.target;
  const donationForm     = amountInput.closest('.donation-form');
  if (!donationForm) return;

  const roundedContainer = donationForm.querySelector('.donation-rounded-container');
  const roundedAmount    = donationForm.querySelector('.donation-rounded-amount');
  const customVariantInput     = donationForm.querySelector('.donation-variant-custom');
  const submitButton     = donationForm.querySelector('.donation-submit');

  const raw        = Number(amountInput.value);
  const normalized = closestAllowedAmount(raw);

  if (!normalized) {
    roundedContainer.style.opacity = 0;
    submitButton.disabled = true;
    roundedAmount.textContent = '';
    customVariantInput.value = '';
    return;
  }

  // Look up variant for this amount
  const centsKey  = String(Math.round(normalized * 100));
  const variantId = VARIANT_MAP[centsKey];

  if (!variantId) {
    roundedAmount.textContent = 'N/A';
    customVariantInput.value = '';
    submitButton.disabled = true;
    roundedContainer.style.opacity = 1;
    return;
  }

  submitButton.disabled = false;

  // Hide the "rounded" line if there was no change
  const same = !Number.isNaN(raw) && raw === normalized;
  roundedContainer.style.opacity = same ? 0 : 1;

  roundedAmount.textContent = normalized.toLocaleString('nb-NO');
  customVariantInput.value = variantId;
});

document.addEventListener('submit', (e) => {
  const donationForm = e.target.closest('.donation-form');
  if (!donationForm) return;

  console.log('submit', donationForm);

  const checkedVariantInput = donationForm.querySelector('.donation-variant:checked');
  if (!checkedVariantInput || !checkedVariantInput.value) {
    e.preventDefault();
    alert('Vennligst legg inn et gyldig beløp');
  }
});

